import {useQuery, gql} from "@apollo/client";
import BackendError from "./BackendError";
import {ThreeDots} from "@dvrt/graphql-widgets";
import Number from "./Number";
import RedirectToError from "./RedirectToError";

// Tequet endpoint types
export type EndpointType = "users" | "faxes" | "groups" | "ivrs" | "gateways";

type Props = {
    type: EndpointType;
    id: number;
};

export default function EndpointNumber(props: Props) {
    const query = `query ${props.type}Shard($id: Int!) {
        ${props.type}(id: $id) {
            items {
                number {
                    e164
                    shortNumber
                }
            }
        }
    }`;

    const {loading, error, data} = useQuery(gql(query), {variables: {id: props.id}});

    if (loading) return <ThreeDots height={5} />;

    if (error) return <BackendError error={error} />;

    if (data[props.type].items.length !== 1) return <RedirectToError id="unknown_endpoint" />;

    const endpoint = data[props.type].items[0];

    return <Number {...endpoint.number} />;
}
